import { useEffect, useMemo, useState } from 'react';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useIdentity } from '@zenbusiness/application-commons-identity';

import { recordException } from '#client/utils/reporting';

import { ENTITY_SELECTOR_QUERY } from '../utils/queries';

export default function useBusinessEntitySelector(options = {}) {
  const { identified } = useIdentity();
  const { businessEntityUuid } = useBusinessEntity();
  const [businessEntities, setBusinessEntities] = useState([]);
  const { data, loading, error } = useQuery(ENTITY_SELECTOR_QUERY, {
    skip: !identified,
    errorPolicy: 'all',
    variables: {
      limit: options.limit || 500
    }
  });

  const { businessEntitySelector } = data || {};
  const businessEntitiesData = (loading || !businessEntitySelector)
    ? null
    : businessEntitySelector?.businessEntities;

  const currentEntity = businessEntitiesData?.find(({ uuid }) => uuid === businessEntityUuid);

  useEffect(() => {
    if (loading || !businessEntitiesData) return;

    if (businessEntitiesData?.length !== businessEntities?.length) {
      setBusinessEntities(businessEntitiesData);
    }
  }, [loading, currentEntity, businessEntityUuid, businessEntitiesData, businessEntities?.length]);

  const entitySelectorData = useMemo(() => ({
    error,
    loading,
    currentEntity,
    businessEntities
  }), [
    error,
    loading,
    currentEntity,
    businessEntities
  ]);

  if (error) {
    recordException(error);
  }

  return entitySelectorData;
}
